<template>
  <div class='no-data'>
    <div class='no-data__header'>
      <div class='no-data__header__title' v-if='title'>
        {{title}}
      </div>
      <div class='no-data__header__message' v-if='message'>
        {{message}}
      </div>
      <div class='no-data__header__action'>
        <slot name='action'>
          <div slot='action' class="no-data-action"></div>
        </slot>
      </div>
    </div>
    <div class="no-data__animation" :class="{ 'no-data__animation--dark': isDarkMode }">
      <lottie-animation
        :key="isDarkMode ? 'dark' : 'light'"
        ref="anim"
        :animationData="animationData"
        :loop="true"
        :style="'height: 250px; background-color: transparent'"
      />
    </div>
  </div>
</template>

<script>
import LottieAnimation from 'lottie-web-vue';
import { mapGetters } from 'vuex';
import noDataLight from '@/assets/icons/animations/no-data.json';
import noDataDark from '@/assets/icons/animations/no-data-dark.json';

export default {
  name: 'NoData',
  components: { LottieAnimation },
  props: {
    title: {
      default: 'Nothing to show here',
      required: false,
      type: String,
    },
    message: {
      default: '',
      required: false,
      type: String,
    },
  },
  computed: {
    ...mapGetters('theme', ['isDarkMode']),
    animationData() {
      return this.isDarkMode ? noDataDark : noDataLight;
    },
  },
};
</script>

<style lang='scss' scoped>
@import '~@/assets/styles/design-system';

.no-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-basis: 100%;
  &__header {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: rem(50);
    margin-bottom: $space-4;
    &__title {
      font-family: $font-family-bold;
      font-size: $font-size-4xl;
      color: var(--text-secondary);
      display: flex;
      justify-content: center;
    }
    &__message {
      font-family: $font-family-semibold;
      font-size: $font-size-xl;
      color: var(--text-secondary);
      justify-content: center;
    }
    &__action {
      margin-top: $space-2;
      display: flex;
      flex-direction: column;
      align-items: center;
      font-family: $font-family-semibold;
      font-size: $font-size-xl;
      color: var(--text-secondary);
      justify-content: center;
    }
  }
  &__animation {
    background-color: transparent;
  }
  &__contact-animation {
    height: rem(300);
  }
}
</style>
